import Cookie from 'js-cookie';
import { LocationUtilities, SiteUtilities } from '../utils';
import GA4Utilities from '../utils/ga4-utilities';
import FwcrmFormHandlers from './fwcrm-form-handlers';

const fmarketerSignupForm = function (classname, form) {
  const $form = $(form);
  const signUpApiUrl = $form.data('signup-url') || 'https://aloha.freshworks.com/signup/freshmarketer';
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
  const userEmail = $form.find('.email-fmarketer').val() || $form.find('.email-form').val();
  const phone = $form.find('.phone-form').val() || 'Null';
  const geoLocation = LocationUtilities.getGeoLocation();

  const fmAssetId = $form.find('.fm-asset-id').val() || $form.data('fm_asset_id') || 3649313;
  const tacticId = SiteUtilities.getTacticID() || '';
  const compositeKey = SiteUtilities.getCompositeKey(userEmail, fmAssetId, tacticId);

  const sessionObj = window.session ? JSON.parse(JSON.stringify(window.session)) : {};
  sessionObj.location = geoLocation;
  sessionObj.phonenumber = phone;
  if (sessionObj) {
    sessionObj.composite_stitching_key = compositeKey;
    sessionObj.allocadia_asset_id = fmAssetId;
    sessionObj.allocadia_tactic_id = tacticId;

    sessionObj.ga_client_id = `${SiteUtilities.getGAClientID()}:${compositeKey}`;
  }

  // First figure out whether it is going to be a paid signup or a free signup
  const isExternalIframeSignup = $form.parents('.external-iframe-signup').length;
  const currentReferrer = SiteUtilities.getCurrentReferrer();
  const data = {
    email: userEmail,
    phonenumber: phone,
    gdpr_first_opt_in: ($form.find('input[name="send_promotions"]').is(':checked')),
    country: geoLocation ? geoLocation.countryName : '',
    session_json: JSON.stringify(sessionObj),
    first_referrer: (isExternalIframeSignup && currentReferrer) ? currentReferrer : (Cookie.get('fw_fr') || SiteUtilities.getCurrentLocation()),
    first_landing_url: Cookie.get('fw_flu') || '',
    pre_visits: Cookie.get('fw_vi') || 0,
    fs_cookie: freshsales.anonymous_id || 'Not found'
  };
  try {
    data.plan_name = window.location.href.match(/plan=([\w-]{4,7})/)[1];
    data.visitor_count = window.location.href.match(/visitors=([\w-]{3,5})/)[1];
    data.subscription_period = window.location.href.match(/subscription=([\w-]{6,7})/)[1];
  } catch (e) {
    data.plan_name = '';
    data.visitor_count = '';
    data.subscription_period = '';
  }

  $.ajax({
    url: signUpApiUrl,
    type: 'POST',
    data: JSON.stringify(data),
    accept: 'application/json; charset=UTF-8',
    contentType: 'application/json; charset=UTF-8',
    dataType: 'json',
    success: (response) => {
      const signupResponse = response['signup_status'];
      if (signupResponse.success === true) {
        response.composite_stitching_key = compositeKey;
        fmarketerSignupFormSuccess($form, response);
      } else if (signupResponse.success === false) {
        $form.find('.button').removeClass('button--loading').removeAttr('disabled');
        $form.find('.email-field').addClass('error');
        $form.find('.error-wrapper').empty().append("<em class='error'>This email already exists</em>");
      }
    },
    error: (xhr, status, err) => {
      $form.find('.button').removeClass('button--loading').removeAttr('disabled');
      $form.find('.email-field').addClass('error');
      $form.find('.error-wrapper').empty().append("<em class='error'>This email already exists</em>");
    },
    complete: () => {
      $form.find('.button').removeClass('button--loading').attr('disabled', null);
    }
  });
};

const fmarketerSignupFormSuccess = ($form, response, alohaV2 = false) => {
  const redirect = $form.attr('data-redirect');
  const userEmail = $form.find('.email-fmarketer').val() || $form.find('.email-form').val();
  const emailHash = SiteUtilities.getShaHash(userEmail);
  const phone = $form.find('.phone-form').val() || 'Null';
  // First figure out whether it is going to be a paid signup or a free signup
  const isExternalIframeSignup = $form.parents('.external-iframe-signup').length;
  let redirectUrl = '#';
  let signupResponse;
  let accountId;
  const geoLocation = LocationUtilities.getGeoLocation();

  if (alohaV2) {
    signupResponse = response['product_signup_response'];
    redirectUrl = signupResponse['redirect_url'].replace(/\/$/, '');
    accountId = signupResponse.account.id;
  } else {
    const signupResponse = response['signup_status'];
    redirectUrl = signupResponse['redirect_uri'];
    accountId = signupResponse['account_id'];
  }

  SiteUtilities.configureAssetId($form, 'fmarketer');
  // Freshmarketer Data
  const freshmarketerData = {
    freshmarketerObject: {
      email: userEmail,
      phone: phone,
      country: geoLocation ? geoLocation.countryName : '',
      contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
      custom_field: {
        cf_fmarketersignupreferrer: window.location.href || '',
        cf_freshmarketer_list: $form.find('.fm-list-id').val() || '3755'
      },
      domainUrl: redirectUrl,
      accountId: accountId,
      product: 'Freshmarketer',
      composite_stitching_key: response.composite_stitching_key || null
    }
  };
  GA4Utilities.ga4ThankYouEvent(accountId, redirectUrl, $form);
  SiteUtilities.passSignupResponseToGA(accountId, redirectUrl, 'Freshmarketer');
  localStorage.setItem('redirect_url', redirectUrl);
  // Redirect to thank-you page once Freshmarketer Post is complete.
  jQuery.when(
    SiteUtilities.freshmarketerPost(freshmarketerData, false, $form)
  ).then(function () {
    let thankYouRedirect = `${redirect}/?accountid=${accountId}&ehash=${emailHash}`;
    if (isExternalIframeSignup) {
      thankYouRedirect = thankYouRedirect + '&post_to_partner=true';
    }
    window.location.href = thankYouRedirect;
  });
};

// Freshmarketer Classic Account
const fmarketerClassicAccountLogin = (domain, loginUrl) => {
  const error = {};
  const getData = (url, resolve, reject) => {
    jQuery.getJSON(url).done(
      (data) => {
        const { 'domain-exists': { result } = {} } = data || {};
        if (result) return resolve(`https://${domain}.freshmarketer.com`);
        return reject(Object.assign(error, { status: 404 }));
      }
    ).fail(
      () => {
        return reject(Object.assign(error, { status: 502 }));
      }
    );
  };

  return new Promise((resolve, reject) => {
    if (!domain) reject(Object.assign(error, { status: 400 }));
    getData((loginUrl || 'https://app.freshmarketer.com/ab/api/domain/%domain%/domain-exists').replace(
      '%domain%', domain), resolve, reject);
  });
};

const fmarketerLoginForm = function (classname, form) {
  const $form = $(form);
  const domain = $form.find('input.domain-form').val().trim();
  const subdomainProduct = $form.find('.subdomain-product').val().trim();
  if (!domain || !subdomainProduct) return;

  $form.find('input.domain-form').parents('.form-field').removeClass('error');
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');

  const loginStatus = {
    resolved: null,
    rejected: null
  };

  const loginFailureCallback = (xhr, $form) => {
    if (!$form) return;
    const { status } = xhr || {};
    $form.find('.button').removeClass('button--loading').removeAttr('disabled');
    $form.find('.domain-form').parents('.form-field').addClass('error');
    if (status === 404) {
      $form.find('.error-wrapper').append("<em class='error'>Domain does not exist</em>");
    } else {
      $form.find('.error-wrapper').append("<em class='error'>Error contacting the server</em>");
    }
  };

  (async function () {
    await Promise.all([
      SiteUtilities.returnResolvedPromise(FwcrmFormHandlers.fwcrmAccountLogin(domain, subdomainProduct), loginStatus),
      SiteUtilities.returnResolvedPromise(fmarketerClassicAccountLogin(domain), loginStatus)
    ]);
    const { resolved, rejected } = loginStatus;
    if (resolved) window.location.href = resolved;
    else throw (rejected);
  })().catch(function (err) {
    loginFailureCallback(err, $form);
  });
  GA4Utilities.loginFormSubmit(domain);
};

const fmarketerForgotDomainForm = function (classname, form) {
  const $form = $(form);
  const email = $('.' + classname + ' input[name^=email]').val().trim();
  const forgotDomainUrl = $form.data('forgot-domain-url') || 'https://app.freshmarketer.com/ab/api/domain/forget-domain?emailId=';
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
  if (email) {
    jQuery.getJSON(forgotDomainUrl + encodeURIComponent(email), function (data) {
      if (data['forget-domain'].result) {
        $form.find('.button').removeClass('button--loading').removeAttr('disabled');
        jQuery('.form-wrapper', '.forgot-domain-form-wrapper').slideUp(300);
        setTimeout(function () {
          jQuery('.forgot-domain-success').slideDown(300);
        }, 300);
      } else {
        $form.find('.button').removeClass('button--loading').removeAttr('disabled');
        $('.' + classname + ' input[name^=email-]').parents('.form-field').addClass('error');
        $form.find('.error-wrapper').empty().append("<em class='error'>This email does not exist</em>");
      }
    }).fail(function () {
      $form.find('.button').removeClass('button--loading').removeAttr('disabled');
    });
  } else {
    $form.find('.button').removeClass('button--loading').removeAttr('disabled');
    $('.' + classname + ' input[name^=domain-]').parents('.form-field').addClass('error');
    $form.find('.error-wrapper').empty().append("<em class='error'>Please enter a valid email</em>");
  }
};

const fmarketerDemoRequestForm = (className, form) => {
  const $form = $(form);
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
  const emailid = $form.find('input.email-form').val();
  const emailHash = SiteUtilities.getShaHash(emailid);
  const firstName = $form.find('input.first-name-form').val();
  const lastName = $form.find('input.last-name-form').val();
  const phone = $form.find('input.phone-form').val();
  const companyName = $form.find('input.company-form').val();
  const locationData = LocationUtilities.getGeoLocation();

  // Freshmarketer Data
  const freshmarketerData = {
    freshmarketerObject: {
      first_name: firstName,
      last_name: lastName,
      email: emailid,
      company: companyName,
      phone: phone,
      country: locationData ? locationData.countryName : '',
      contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
      custom_field: {
        cf_leadsource: 'Demo Form',
        cf_freshmarketer_list: $form.find('.fm-list-id').val()
      }
    }
  };

  setTimeout(function () {
    jQuery.when(
      SiteUtilities.freshmarketerPost(freshmarketerData, false, form)
    ).then(function () {
      window.location.href = $form.attr('data-redirect') + `/?ehash=${emailHash}`;
    });
  }, 300);
};

const fmarketerTemplateSelectionForm = (className, form) => {
  const $form = $(form);
  $form.find('.button').addClass('button--loading');
  const domain = $form.find('.helpdesk-form').val();
  const templateId = $form.attr('data-template-id');
  const href = `https://${domain}.freshmarketer.com/mas/#/journey-templates/${templateId}/template`;
  window.location.href = href;
};

export default {
  fmarketerSignupForm,
  fmarketerLoginForm,
  fmarketerForgotDomainForm,
  fmarketerDemoRequestForm,
  fmarketerTemplateSelectionForm,
  fmarketerSignupFormSuccess
};
